import { FontTTHoves } from '@m/assets/fonts/tt-hoves/FontTTHoves';
import MaintenancePage from '@m/components/MaintenancePage/MaintenancePage';
import { MAINTENANCE_MODE } from '@m/config/FeatureFlags';
import { BrowserRouter } from 'react-router-dom';

import SharedProviders from './shared';

import type { ThemeName } from '@m/components-ui/themes/registry';

export interface ProvidersProps {
  children?: React.ReactNode;
  defaultTheme?: 'light' | 'dark';
  onThemeChange?: (theme: ThemeName) => void;
  themeName?: ThemeName;
}

export default function Providers({
  children,
  defaultTheme = 'light',
  onThemeChange,
  themeName,
}: ProvidersProps) {
  return (
    <SharedProviders
      defaultTheme={defaultTheme}
      themeName={themeName}
      onThemeChange={onThemeChange}
    >
      <FontTTHoves />
      {MAINTENANCE_MODE ? <MaintenancePage /> : <BrowserRouter>{children}</BrowserRouter>}
    </SharedProviders>
  );
}
